import React from "react";
import styles from "./DropDownMenu.module.css";

function DropDownMenu({ inicio, gallery, aboutMe, contact, faq }) {
  return (
    <div className={styles.container}>
      <button className={styles.btn} onClick={inicio}>
        Inicio
      </button>

      <button className={styles.btn} onClick={gallery}>
        Galería
      </button>
      <button className={styles.btn} onClick={aboutMe}>
        Sobre Mí
      </button>
      <button className={styles.btn} onClick={contact}>
        Contacto
      </button>
      <button className={styles.btn} onClick={faq}>
        Preguntas frecuentes
      </button>
    </div>
  );
}

export { DropDownMenu };
